import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cacheable, CacheBuster } from 'ts-cacheable';
import { Observable, Subject } from 'rxjs';
import { CommunityServiceCategoryEdit, CommunityServiceCategoryList } from 'src/app/community/model/community-service-category';
import { CommunityServiceCorrectionEmail } from 'src/app/shared/community-service-info/community-service-correction-email';


const communityServiceCategoryCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class CommunityServiceCategoryService
{

  constructor(private http: HttpClient) { }

  /**
   * Get all cached Community Service Categories.
   */
  @Cacheable(
    {
      cacheBusterObserver: communityServiceCategoryCacheBuster
    })
  public getCachedCommunityServiceCategories(): Observable<CommunityServiceCategoryList[]>
  {
    return this.http.get<CommunityServiceCategoryList[]>('/community/service/categories/list');
  }

  /**
   * Delete a Community Service Category.
   *
   * @param id Community Service Category id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: communityServiceCategoryCacheBuster
    })
  public deleteCommunityServiceCategory(id: number): Observable<CommunityServiceCategoryEdit>
  {
    return this.http.delete<CommunityServiceCategoryEdit>(`/community/service/category/${id}`);
  }

  /**
   * Save a Community Service Category.
   *
   * @param data Community Service Category to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: communityServiceCategoryCacheBuster
    })
  public saveCommunityServiceCategory(data: any, isNew: boolean, id?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/community/service/category', data);
    }
    else
    {
      return this.http.put(`/community/service/category/${id}`, data);
    }
  }

  /**
   * Get Community Service Categories.
   */
  public getCommunityServiceCategoriesList(): Observable<CommunityServiceCategoryList[]>
  {
    return this.http.get<CommunityServiceCategoryList[]>('/community/service/categories/list');
  }

  /**
   * Check if Community Service Category is in use
   *
   * @param id Community Service Category id
   */
  public existsCommunityServiceCategory(id: number): Observable<any>
  {
    return this.http.get(`/community/service/category/inuse/${id}`);
  }

  /**
   * Check if Community Service Category Name exists to avoid name duplicates
   *
   * @param name Community Service Category Name
   */
  public existsCommunityServiceCategoryName(name: string): Observable<any>
  {
    return this.http.get(`/community/service/category/exists?name=${name}`);
  }

  /**
   * Get a Community Service Category by id.
   *
   * @param id Community Service Category id
   */
  public getCommunityServiceCategoryById(id: number): Observable<CommunityServiceCategoryEdit>
  {
    return this.http.get<CommunityServiceCategoryEdit>(`/community/service/category/${id}`);
  }

  public sendCommunityServiceCorrectionByEmail(data: CommunityServiceCorrectionEmail): Observable<any>
  {
    return this.http.post('/community/service/correction/email', data);
  }

  public findCorrectionsByDirectoryManager(programId: number, directoryManagerEmail: string): Observable<any>  
  {
    return this.http.get(`/community/service/correction/exists?programId=${programId}&directoryManagerEmail=${directoryManagerEmail}`);
  }
}
